export const STUDY_ACTION_TYPES = {
  STUDY_SET_DATA_BY_KEY: 'STUDY_SET_DATA_BY_KEY',
  STUDY_SET_LINK_BY_KEY: 'STUDY_LINK_DATA_BY_KEY',
  STUDY_CHANGE_PROCESSING: 'STUDY_CHANGE_PROCESSING',
  STUDY_CLEAR_STATE: 'STUDY_CLEAR_STATE',
};

export function setStudyDataByKey(data, stateKeyForDataSaving) {
  return {
    type: STUDY_ACTION_TYPES.STUDY_SET_DATA_BY_KEY,
    payload: {
      data,
      stateKeyForDataSaving,
    },
  };
}

export function setStudyLinkByKey(data, stateKeyForLink) {
  return {
    type: STUDY_ACTION_TYPES.STUDY_SET_LINK_BY_KEY,
    payload: {
      data,
      stateKeyForLink,
    },
  };
}

export function clearStudyState(clearedKey, shouldDeleteProperty = false) {
  return {
    type: STUDY_ACTION_TYPES.STUDY_CLEAR_STATE,
    payload: {
      clearedKey,
      shouldDeleteProperty,
    },
  };
}
export function changeStudyProcessingState(newState) {
  return {
    type: STUDY_ACTION_TYPES.STUDY_CHANGE_PROCESSING,
    payload: newState,
  };
}

export function getStudyData(pageObject, stateKeyForDataSaving, methodUrl) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeStudyProcessingState(true));

    const response = await axios.get(methodUrl);

    dispatch(changeStudyProcessingState(false));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data = {}, accessRequest, hasAccess } = response;
    data.hasAccess = hasAccess;

    dispatch(setStudyDataByKey(data, stateKeyForDataSaving));

    if (accessRequest !== undefined) {
      dispatch(setStudyDataByKey(accessRequest, 'accessRequest'));
    }

    return response;
  };
}

export function getStudyLink(stateKeyForLink, data) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    dispatch(setStudyLinkByKey(data, stateKeyForLink));
  };
}
